import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CodeEditorComponentModule, FormFieldComponentModule } from '@selfai-platform/pipeline-shared';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CmsFormComponent } from './cms-form.component';

const fieldComponents: NgModule['imports'] = [InputTextModule, DropdownModule, CodeEditorComponentModule];

@NgModule({
  imports: [CommonModule, FormFieldComponentModule, FormsModule, ReactiveFormsModule, CardModule, ...fieldComponents],
  declarations: [CmsFormComponent],
  exports: [CmsFormComponent],
})
export class CmsFormComponentModule {}
